// @flow

import React, { Component } from 'react';
import type { JoueurType, JoueurFiltersSearchType } from 'types/Joueur';
import type { SeasonListType } from 'types/Seasons';
import DropdownMultiInput from 'components/fragments/input/DropdownMultiInput';
import DropdownRadioInput from 'components/fragments/input/DropdownRadioInput';
import _ from 'lodash';

type Props = {
  joueurs: JoueurType[],
  slug: string,
  seasons: SeasonListType[],
  seasonFilter: number | null,
  searchPlayer: (searchedPlayer: string) => void,
  onFilterChange: (filters: JoueurFiltersSearchType, filterType: string) => void,
  initialFilters: JoueurFiltersSearchType,
  title: string,
  genre: string,
  defaultSeason: string
};

type State = {
  competitions: Array<{ value: string, label: string }>,
  postes: Array<{ id: number, name: string }>,
  playersFilters: JoueurFiltersSearchType
};

const getInitialState = (props: Props, state: State) => {
  const { joueurs, seasonFilter, seasons, slug } = props;
  const { playersFilters, postes: postesInState, competitions: competitionsInState } = state;

  if (joueurs && joueurs.length > 0) {
    // pour filtre des postes
    const postes: Array<Object> = [];
    joueurs.forEach(joueur => {
      const isObjectPosteExists = postes.findIndex(poste => poste.name === joueur.poste.name);
      if (isObjectPosteExists === -1) {
        postes.push(joueur.poste);
      }
    });

    let retour = { playersFilters: { ...props.initialFilters, equipe: slug } };
    if (postes.length > postesInState.length) {
      retour = { postes, ...retour };
    }

    // pour filtre des compétitions
    let competitions: Array<Object> = [];
    if (seasonFilter) {
      competitions = getCurrentSeasonCompetitions(seasons, seasonFilter);
    }
    if (competitions !== competitionsInState) {
      retour = { competitions, ...retour };
    }
    return retour;
  } else {
    return { playersFilters: { ...playersFilters, equipe: slug }, competitions: [] };
  }
};

const getCurrentSeasonCompetitions = (seasons, currentSeasonId) => {
  const currentSeason = seasons.find(season => season.id === currentSeasonId);
  const competitions = currentSeason ? currentSeason.competitions : [];

  return competitions;
};

export default class TeamPlayersFilters extends Component<Props, State> {
  props: Props;
  state: State = {
    competitions: [],
    postes: [],
    playersFilters: {
      equipe: '',
      season: null,
      poste: [],
      competitions: []
    }
  };


  convertToOptions = (options: Array<Object>, reverseBool?: boolean): Array<Object> => {
    const dropdownOptions = options.map((option): Object => ({
      label: option.name || option.label,
      value: option.id || option.value
    }));
    return reverseBool ? dropdownOptions.reverse() : dropdownOptions;
  };

  onInputChange = (filterType: string, value: string) => {
    const { onFilterChange } = this.props;

    this.setState(
      (prevState: State) => {
        let newState = [];
        const filters = prevState.playersFilters[filterType];

        if (filters.includes(value)) {
          newState = filters.filter(filter => filter !== value);
        } else {
          newState = [...filters, value];
        }

        return {
          ...prevState,
          playersFilters: {
            ...prevState.playersFilters,
            [filterType]: newState
          }
        };
      },
      () => onFilterChange(this.state.playersFilters, filterType)
    );
  };

  onMultiInputChange = (value: string) => {
    const { postes } = this.state;
    const isPoste = postes.filter(poste => poste.id === value).length > 0;
    const type = isPoste ? 'poste' : 'competitions';
    return this.onInputChange(type, value);
  };

  getTitleName = () => ({
    postes: 'Tous les postes',
    competitions: 'Toutes les compétitions'
  });

  convertToMultiOptions = (playersFilters: Object) => {
    const titles = Object.keys(playersFilters);
    const titleName = this.getTitleName();

    return titles.reduce((result, title) => {
      result.push({ label: titleName[title] });

      let filters;
      if (title !== 'competitions') {
        filters = playersFilters[title].map(playerFilter => ({
          label: playerFilter.name,
          value: playerFilter.id
        }));
      } else {
        filters = this.state.competitions;
      }

      return [...result, ...filters];
    }, []);
  };

  selectSeason = (value: string) => {
    const { onFilterChange } = this.props;
    const season = parseInt(value, 10);

    this.setState(
      (prevState: State) => ({
        ...prevState,
        playersFilters: {
          ...prevState.playersFilters,
          season
        }
      }),
      () => onFilterChange(this.state.playersFilters, 'saison')
    );
  };

  searchPlayer = (e: SyntheticInputEvent<EventTarget>) => {
    const { searchPlayer } = this.props;
    searchPlayer(e.target.value);
  };

  getLabelSeason = () => {
    const { seasons } = this.props;

    const {
      playersFilters: { season }
    } = this.state;
    const prelabel = seasons.filter(saison => saison.id === season);

    return prelabel.length === 1 ? prelabel[0].name : this.props.defaultSeason;
  };

  componentDidMount = () => {
    const { initialFilters } = this.props;
    if (initialFilters) {
      const state =  getInitialState(this.props, this.state);
      this.setState(state);
    }
  };

  componentDidUpdate = (prevProps: Props) => {
    const { initialFilters } = this.props;
    if (!_.isEqual(prevProps.joueurs, this.props.joueurs) ) {
      const state =  getInitialState(this.props, this.state);
      this.setState(state);
    }
    if (prevProps.initialFilters && initialFilters && !_.isEqual(prevProps.initialFilters, initialFilters)) {
      this.setState({playersFilters: initialFilters});
    }
  }

  render() {
    const { seasons, joueurs, title, genre, initialFilters } = this.props;
    const seasonsJoueurs = seasons.filter(season => season.joueurs === true);
    const { postes, competitions } = this.state;
    return (
      <>
        <div className="row">
          <div className="col">
            <div className="header-filter header-filter--team header-filter--teamWfilter mt-2">
              <div className="row">
                <div className="col col-lg-8on9">
                  <div className="header-filter__left">
                    {seasonsJoueurs && seasonsJoueurs.length > 0 && (
                      <DropdownRadioInput
                        prelabel={'Saison '}
                        label={this.getLabelSeason()}
                        id="Saisons"
                        options={this.convertToOptions(seasonsJoueurs, true)}
                        inputChanged={this.selectSeason}
                        noBorder
                        maj
                        title
                        isPreLabelThin={false}
                      />
                    )}

                    <div className="multi-dropdown">
                      <div className="multi-dropdown__desktop">
                        {competitions && competitions.length > 0 && (
                          <DropdownMultiInput
                            label="Toutes les compétitions"
                            id="Compétitions"
                            options={this.convertToOptions(competitions)}
                            inputChanged={value => this.onInputChange('competitions', value)}
                            selected={initialFilters.competitions}
                            className={'dropdown dropdown--noBorder dropdown--checkbox'}
                            closeOnSelect={true}
                          />
                        )}

                        {postes && postes.length > 0 && !title.match('7') && (
                          <DropdownMultiInput
                            label="Tous les postes"
                            id="Postes"
                            options={this.convertToOptions(postes)}
                            inputChanged={value => this.onInputChange('poste', value)}
                            selected={initialFilters.poste}
                            className={'dropdown dropdown--noBorder dropdown--checkbox'}
                            closeOnSelect={true}
                          />
                        )}
                      </div>

                      {joueurs && !!joueurs.length && (
                        <div className="multi-dropdown__mobile">
                          <DropdownMultiInput
                            label="Autres Filtres"
                            id="MultiDropdown"
                            options={this.convertToMultiOptions({ postes, competitions })}
                            inputChanged={value => this.onMultiInputChange(value)}
                            selected={[...initialFilters.poste, ...initialFilters.competitions]}
                            className={'dropdown dropdown--noBorder dropdown--checkbox'}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {joueurs && joueurs.length > 0 && (
                    <div className="header-filter__right">
                      <form>
                        <div className="input input--dropdown">
                          <input
                            type="search"
                            placeholder={genre === 'M' ? "Saisir le nom d'un joueur" : "Saisir le nom d'une joueuse"}
                            onChange={e => this.searchPlayer(e)}
                          />
                          <div className=""></div>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="header-filter__sep mb-4"></div>
          </div>
        </div>
      </>
    );
  }
}
